const WEEKLY_SUPER_DISCOUNT = {
  discPrice: 5.5,
  roundedDiscPrice: 550,
  discPricePerWeek: 5.53,
  discPricePerDay: 0.79,
  chargebeeId: 'kegel-l1ndw-USD-Monthly',
} satisfies PaymentModel;

const BASELINE_MONTH_FITNESS_DATA = {
  fullPrice: 9.99,
  periodKey: 'subscription_period_1month',
  planNameUpper: '',
  currencyCode: 'USD',
  currencySymbol: '$',
  standard: {
    chargebeeId: 'Fitness-l1-USD-Monthly',
    discPrice: 6.69,
    roundedDiscPrice: 669,
  },
  super: {
    chargebeeId: 'Fitness-l1d-USD-Monthly',
    discPrice: 3.3,
    roundedDiscPrice: 330,
  },
} satisfies Omit<AddonPaymentModel, 'id'>;

const BASELINE_FITNESS: AddonPaymentModel[] = [
  {
    id: 1,
    ...BASELINE_MONTH_FITNESS_DATA,
  },
  {
    id: 2,
    ...BASELINE_MONTH_FITNESS_DATA,
  },
  {
    id: 3,
    fullPrice: 29.99,
    periodKey: 'subscription_period_3months',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId: 'Fitness-l1-USD-Every-3-months',
      discPrice: 19.99,
      roundedDiscPrice: 1999,
    },
    super: {
      chargebeeId: 'Fitness-l1d-USD-Every-3-months',
      discPrice: 9.99,
      roundedDiscPrice: 999,
    },
  },
  {
    id: 1,
    ...BASELINE_MONTH_FITNESS_DATA,
  },
];

const BASELINE_PLANS: SubscriptionModel[] = [
  {
    id: 1,
    fullPrice: 10.59,
    fullPricePerDay: 1.5,
    planName: 'subscription_1week_kegel_plan',
    planNameUpper: 'lp_v7_plan_1week',
    periodKey: 'subscription_period_1week',
    renewalPeriodKey: 'subscription_period_1month',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '1 week',
    weeklyRenewalPrice: 31,
    standard: {
      discPrice: 6.99,
      roundedDiscPrice: 699,
      discPricePerWeek: 6.99,
      discPricePerDay: 0.99,
      chargebeeId: 'kegel-l1nw-USD-Monthly',
    },
    super: WEEKLY_SUPER_DISCOUNT,
    fitness: BASELINE_FITNESS[0],
  },
  {
    id: 2,
    fullPrice: 31,
    fullPricePerDay: 1,
    fullPricePerWeek: 7,
    planName: 'subscription_1month_kegel_plan',
    planNameUpper: 'lp_v7_plan_1month',
    periodKey: 'subscription_period_1month',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '1 month',
    standard: {
      discPrice: 15.19,
      roundedDiscPrice: 1519,
      discPricePerWeek: 3.43,
      discPricePerDay: 0.49,
      chargebeeId: 'kegel-l1n-USD-Monthly',
    },
    super: {
      discPrice: 11.99,
      roundedDiscPrice: 1199,
      discPricePerWeek: 2.73,
      discPricePerDay: 0.39,
      chargebeeId: 'kegel-l1nd-USD-Monthly',
    },
    fitness: BASELINE_FITNESS[1],
  },
  {
    id: 3,
    fullPrice: 53.04,
    fullPricePerDay: 0.59,
    planName: 'subscription_3months_kegel_plan',
    planNameUpper: 'lp_v7_plan_3months',
    periodKey: 'subscription_period_3months',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '3 month',
    standard: {
      discPrice: 25.99,
      roundedDiscPrice: 2599,
      discPricePerWeek: 2.03,
      discPricePerDay: 0.29,
      chargebeeId: 'kegel-l1n-USD-Every-3-months',
    },
    super: {
      discPrice: 21.49,
      roundedDiscPrice: 2149,
      discPricePerWeek: 1.68,
      discPricePerDay: 0.24,
      chargebeeId: 'kegel-l1nd-USD-Every-3-months',
    },
    fitness: BASELINE_FITNESS[2],
  },
];

const FITNESS_PLANS: AddonPaymentModel[] = [
  {
    id: 1,
    fullPrice: 29.99,
    periodKey: 'subscription_period_4week',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId: 'Fitness-e2-USD-Every-4-weeks',
      discPrice: 19.99,
      roundedDiscPrice: 1999,
    },
    super: {
      chargebeeId: 'Fitness-e2d-USD-Every-4-weeks',
      discPrice: 9.99,
      roundedDiscPrice: 999,
    },
  },
  {
    id: 2,
    fullPrice: 59.99,
    periodKey: 'subscription_period_12week',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId: 'Fitness-e2-USD-Every-12-weeks',
      discPrice: 39.99,
      roundedDiscPrice: 3999,
    },
    super: {
      chargebeeId: 'Fitness-e2d-USD-Every-12-weeks',
      discPrice: 19.99,
      roundedDiscPrice: 1999,
    },
  },
  {
    id: 3,
    fullPrice: 104.99,
    periodKey: 'subscription_period_24week',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId: 'Fitness-e2-USD-Every-24-weeks',
      discPrice: 69.99,
      roundedDiscPrice: 6999,
    },
    super: {
      chargebeeId: 'Fitness-e2d-USD-Every-24-weeks',
      discPrice: 34.99,
      roundedDiscPrice: 3499,
    },
  },
];

const WW_PRICING_C_FITNESS_PLANS: AddonPaymentModel[] = [
  {
    id: 1,
    fullPrice: 9.99,
    periodKey: 'subscription_period_4week',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId: 'Fitness-l1-USD-Every-4-weeks',
      discPrice: 6.69,
      roundedDiscPrice: 669,
    },
    super: {
      chargebeeId: 'Fitness-l1d-USD-Every-4-weeks',
      discPrice: 3.3,
      roundedDiscPrice: 330,
    },
  },
  {
    id: 2,
    fullPrice: 29.99,
    periodKey: 'subscription_period_12week',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId: 'Fitness-l1-USD-Every-12-weeks',
      discPrice: 19.99,
      roundedDiscPrice: 1999,
    },
    super: {
      chargebeeId: 'Fitness-l1d-USD-Every-12-weeks',
      discPrice: 9.99,
      roundedDiscPrice: 999,
    },
  },
];

export const VARIANT_C_PLANS: SubscriptionModel[] = [
  {
    id: 1,
    fullPrice: 14.25,
    fullPricePerDay: 2.03,
    planName: 'subscription_1week_kegel_plan',
    planNameUpper: 'lp_v7_plan_1week',
    periodKey: 'subscription_period_1week',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '1 week',
    weeklyRenewalPrice: 31,
    renewalPeriodKey: 'subscription_period_4week',
    standard: {
      discPrice: 9.19,
      roundedDiscPrice: 919,
      discPricePerDay: 1.31,
      chargebeeId: 'kegel-e2-cw-USD-Every-4-weeks',
    },
    super: {
      discPrice: 9.19,
      roundedDiscPrice: 919,
      discPricePerDay: 1.31,
      chargebeeId: 'kegel-e2-cw-USD-Every-4-weeks',
    },
    fitness: FITNESS_PLANS[0],
  },
  {
    id: 2,
    fullPrice: 31,
    fullPricePerDay: 1.1,
    planName: 'subscription_4week_kegel_plan',
    planNameUpper: 'lp_v7_plan_4week',
    periodKey: 'subscription_period_4week',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '4 week',
    standard: {
      discPrice: 19.99,
      roundedDiscPrice: 1999,
      discPricePerDay: 0.71,
      chargebeeId: 'kegel-e2-c-USD-Every-4-weeks',
    },
    super: {
      discPrice: 14.99,
      roundedDiscPrice: 1499,
      discPricePerDay: 0.53,
      chargebeeId: 'kegel-e2-c-d-USD-Every-4-weeks',
    },
    fitness: FITNESS_PLANS[0],
  },
  {
    id: 3,
    fullPrice: 53,
    fullPricePerDay: 0.63,
    planName: 'subscription_12week_kegel_plan',
    planNameUpper: 'lp_v7_plan_12week',
    periodKey: 'subscription_period_12week',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '12 week',
    standard: {
      discPrice: 35.51,
      roundedDiscPrice: 3551,
      discPricePerDay: 0.42,
      chargebeeId: 'kegel-e2-c-USD-Every-12-weeks',
    },
    super: {
      discPrice: 24.99,
      roundedDiscPrice: 2499,
      discPricePerDay: 0.3,
      chargebeeId: 'kegel-e2-c-d-USD-Every-12-weeks',
    },
    fitness: FITNESS_PLANS[1],
  },
];

function createUpsell111Addon(chargebeeId: string): AddonPaymentModel {
  return {
    id: 1,
    fullPrice: 9.99,
    periodKey: 'subscription_period_4week',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      chargebeeId,
      discPrice: 9.99,
      roundedDiscPrice: 999,
    },
    super: {
      chargebeeId,
      discPrice: 9.99,
      roundedDiscPrice: 999,
    },
  };
}

const UPSELL_111_ADDONS: SubscriptionUpsells = {
  groinFitness: createUpsell111Addon('Fitness-t1-USD-Every-4-weeks'),
  sexologyCourses: createUpsell111Addon('Sexology-t1-USD-Every-4-weeks'),
  guidedMeditations: createUpsell111Addon('Meditations-t1-USD-Every-4-weeks'),
};

export const UPSELL_111_PLANS: SubscriptionModel[] = VARIANT_C_PLANS.map(plan => ({
  ...plan,
  subscriptionUpsells: plan.id === 1 || plan.id === 2
    ? {
      groinFitness: {
        ...UPSELL_111_ADDONS.groinFitness,
        id: plan.id,
      },
      sexologyCourses: {
        ...UPSELL_111_ADDONS.sexologyCourses,
        id: plan.id,
      },
      guidedMeditations: {
        ...UPSELL_111_ADDONS.guidedMeditations,
        id: plan.id,
      },
    }
    : undefined,
}));

export const WW_PRICING_C_PLANS: SubscriptionModel[] = VARIANT_C_PLANS.map(plan => ({
  ...plan,
  fitness: plan.id === 3 ? WW_PRICING_C_FITNESS_PLANS[1] : WW_PRICING_C_FITNESS_PLANS[0],
}));

const COURSE_PLAN: SubscriptionModel[] = [
  {
    id: 1,
    fullPrice: 90,
    periodKey: '',
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: {
      discPrice: 48,
      roundedDiscPrice: 4800,
      chargebeeId: 'sexology_1-USD',
      disclaimer: {
        translationKey: 'oldTranslations.upsale.courses.disclaimer',
        interpolationParams: ['48.00 USD', ''],
      },
    },
    super: {
      discPrice: 29,
      roundedDiscPrice: 2900,
      chargebeeId: 'sexology_2-USD',
      disclaimer: {
        translationKey: 'oldTranslations.upsale.courses.disclaimer',
        interpolationParams: ['29.00 USD', ''],
      },
    },
  },
];

export { BASELINE_FITNESS, BASELINE_PLANS, COURSE_PLAN, WW_PRICING_C_FITNESS_PLANS };
